import { Observable } from "rxjs";
import { CommunityClub, CommunityClubSortBy } from "@app/core/community/domain/model/community-club";
import { ClubFilterCategory } from "@app/core/community/domain/model/club-filter-category";

export interface CommunityClubsQuery {
  search?: string | null;
  lat?: number | null;
  lng?: number | null;
  sortBy?: CommunityClubSortBy | null;
  filter?: ClubFilterCategory | null;
  page?: number;
  pageSize?: number;
  showAll?: boolean;
  onlyFavorites?: boolean;
}

export interface CommunityClubsPage {
  clubs: CommunityClub[];
  total: number;
}

export abstract class CommunityRepo {
  abstract getClubs(query: CommunityClubsQuery): Observable<CommunityClubsPage>;
  abstract getClubById(id: string): Observable<CommunityClub>;
  abstract toggleFavorite(id: string, isFavorite: boolean): Observable<boolean>;
}
